export default __webpack_public_path__ + "static/media/CentraNo2-Book.b8c86866.woff";